module.exports = __webpack_public_path__ + "static/media/sa.479bb907.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sa.svg
// module id = 936
// module chunks = 0